/**
 * クエリパラメータを生成する
 *
 * @param params
 * @returns query
 */
export const buildQueryString = (params) => {
    const query = Object.keys(params)
        .filter(key => params[key] !== '' && params[key] !== null)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return query ? `?${query}` : '';
};
//# sourceMappingURL=buildQueryString.js.map